import { render, staticRenderFns } from "./listPost.vue?vue&type=template&id=2bfe87d8&scoped=true&"
import script from "./listPost.vue?vue&type=script&lang=js&"
export * from "./listPost.vue?vue&type=script&lang=js&"
import style0 from "./listPost.vue?vue&type=style&index=0&id=2bfe87d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe87d8",
  null
  
)

export default component.exports